import { CrudPage } from '@restavo/crud';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DataTableSkeleton, InlineNotification } from '@carbon/react';
import { useOrgInvitationsPage } from 'src/features/orgInvitations';
import { OrgInvitationRow } from 'src/hooks/useInvitations';

const OrgInvitations = React.memo(() => {
  const { t } = useTranslation();
  const { page, organizationId } = useOrgInvitationsPage();
  const [copied, setCopied] = useState(false);

  // The CRUD list is keyed on the tenant params (orgSlug/restaurantId), NOT on the
  // organization id these auth endpoints need. Rendering the page before the id resolves
  // would fetch with nothing to fetch for, and React Query would cache that empty result
  // under a key that never changes again — a permanently empty table. Hold the skeleton
  // until the id is known.
  if (!organizationId) {
    return <DataTableSkeleton columnCount={5} rowCount={5} />;
  }

  return (
    <>
      <CrudPage
        {...page}
        // Invitations are created from Members and never edited; cancelling one is the
        // delete, which stays enabled.
        canCreate={false}
        canUpdate={false}
        extraActions={[
          {
            labelKey: 'orgSettings.invitations.copyLink',
            onClick: async (row: OrgInvitationRow) => {
              await navigator.clipboard.writeText(`${window.location.origin}/accept-invitation/${row.id}`);
              setCopied(true);
            },
          },
        ]}
      />
      {copied && (
        <InlineNotification
          kind="success"
          title={t('orgSettings.invitations.linkCopied')}
          lowContrast
          onClose={() => setCopied(false)}
        />
      )}
    </>
  );
});

export default OrgInvitations;
